import { defineStore } from 'pinia';

export type Snack = {
  timeout?: number;
  closable?: boolean;
  text: string;
};

interface State {
  queue: Snack[];
}

export const useSnackbarStore = defineStore('snackbar', {
  state: (): State => ({
    queue: [],
  }),
  getters: {},
  actions: {
    push(snack: Snack) {
      this.queue.push(snack);
      this.queue = [...this.queue];
    },
    shift() {
      return this.queue.shift();
    },
  },
});
